import { render } from "./ProductCreateCollectionComponent.vue?vue&type=template&id=486ee40a&scoped=true"
import script from "./ProductCreateCollectionComponent.vue?vue&type=script&lang=js"
export * from "./ProductCreateCollectionComponent.vue?vue&type=script&lang=js"

import "./ProductCreateCollectionComponent.vue?vue&type=style&index=0&id=486ee40a&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486ee40a"]])

export default __exports__